import React, { useEffect, useState } from "react";
import AdminNavbar from "./AdminComponent/AdminNavbar";
import { a20, a18, a21, a36 } from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { AiOutlineEdit } from "react-icons/ai";
import { InfinitySpin } from "react-loader-spinner";
import { AiOutlineClose } from "react-icons/ai";

export default function AdminAddProductType() {
  const [category_id, setCategory_id] = useState("");
  const [productTitle, setProductTitle] = useState("");
  const [label, setLabel] = useState("");
  const [slug, setSlug] = useState("");
  const [description, setDescription] = useState("");
  const [categories, setCategories] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [productTypeData, setProductTypeData] = useState([]);
  const [hsnCode, setHsnCode] = useState("");

  const [popUp, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productInUpdate, setProductInUpdate] = useState([]);

  const allStates = useSelector((state) => state);
  const sidebarState = allStates.reducer6.isOpen;
  const adminLoggedIn = allStates.reducer5;
  let Entryby_Staff_id = parseInt(adminLoggedIn);
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, [showForm]);

  const fetchAllProducts = async () => {
    await fetch(a20)
      .then((res) => res.json())
      .then((data) => setProductTypeData(data.data));
  };

  useEffect(() => {
    fetchAllProducts();
  }, [showForm]);
  useEffect(() => {
    fetch(a18)
      .then((res) => res.json())
      .then((data) => setCategories(data.data));
  }, [showForm]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // const formData = new FormData();

    // formData.append("Category_id", category_id);
    // formData.append("ProductTitle", productTitle);
    // formData.append("Label", label);
    // formData.append("Description", description);
    // setCategory_id(parseInt(category_id));
    const formData = {
      Category_id: category_id,
      ProductTitle: productTitle,
      Label: label,
      Slug: slug,
      HSNCode: hsnCode,
      Description: description,
    };

    try {
      const response = await fetch(a21, {
        // body: formData,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      // alert("Product Type Added");
      setShowForm(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleInputChange = (e, property) => {
    const updatedProduct = {
      ...productInUpdate,
      [property]: e.target.value,
    };

    setProductInUpdate(updatedProduct);
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = {
      Id: productInUpdate.id,

      Category_id: productInUpdate.category_id,
      ProductTitle: productInUpdate.productTitle,

      // HSNCode: hsnCode,
      Slug: productInUpdate.slug,
      Label: productInUpdate.label,
      HsnCode: productInUpdate.hsnCode,
      Description: productInUpdate.description,
      // Entryby_Staff_id: Entryby_Staff_id,
      // Id: productInUpdate.id,
      // Name: productInUpdate.name,
      // ParentsCategory: productInUpdate.parentsCategory,
      // Description: productInUpdate.description,
      // Slug: productInUpdate.slug,
      // Label: productInUpdate.label,
      // Entryby_Staff_id: Entryby_Staff_id,
    };

    try {
      const response = await fetch(a36, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      // alert("updated");
      setLoading(false);
      fetchAllProducts();
      setProductInUpdate([]);
      setPopup(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="adminHomeMainBox">
      <div className="navBox">
        <AdminNavbar />
      </div>
      <div
        className={
          sidebarState ? "adminContentbox" : "adminContentbox adminContentbox2"
        }
      >
        {showForm ? (
          <div
            style={{ flexDirection: "column" }}
            className="adminAddCategoryMainbox"
          >
            <button
              style={{
                width: "200px",
                alignSelf: "flex-start",
                margin: "2rem",
                marginBottom: "0",
              }}
              onClick={() => {
                setShowForm(!showForm);
              }}
            >
              Back To Product List
            </button>
            <div className="adminAddCategoryMainbox">
              <form onSubmit={handleSubmit}>
                <h3>ADD PRODUCT </h3>
                <label htmlFor="category">Category:</label>
                <select
                  required="required"
                  value={category_id}
                  onChange={(e) => setCategory_id(e.target.value)}
                >
                  <option value="">Select an option</option>
                  {categories.map((x) => {
                    return <option value={parseInt(x.id)}>{x.name}</option>;
                  })}
                </select>

                <label htmlFor="productTitle">Product Title:</label>
                <input
                  required="required"
                  type="text"
                  id="productTitle"
                  value={productTitle}
                  onChange={(e) => setProductTitle(e.target.value)}
                />
                <label htmlFor="slug">Slug:</label>
                <input
                  required="required"
                  type="text"
                  id="slug"
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                />
                <label htmlFor="label">Label:</label>
                <input
                  required="required"
                  maxLength={4}
                  type="text"
                  id="label"
                  value={label.toUpperCase()}
                  onChange={(e) => setLabel(e.target.value)}
                />
                <label htmlFor="hsn">HSN Code:</label>
                <input
                  type="text"
                  id="hsn"
                  value={hsnCode}
                  onChange={(e) => setHsnCode(e.target.value)}
                />
                <label htmlFor="description">Description:</label>
                <input
                  // required="required"
                  type="text"
                  id="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                <button type="submit">Submit</button>
              </form>
            </div>
          </div>
        ) : (
          <div
            style={{ flexDirection: "column" }}
            className="adminAddCategoryMainbox"
          >
            <button
              style={{
                width: "200px",
                alignSelf: "flex-end",
                margin: "2rem",
                marginBottom: "0",
              }}
              onClick={() => {
                setShowForm(!showForm);
                // setProductTypeData("");
              }}
            >
              Add New Product
            </button>
            <div className="adminAddCategoryMainbox">
              <form style={{ width: "100%" }}>
                <h3 style={{ width: "100%" }}>Products</h3>
                <table
                  className="allCustomersTable"
                  style={{ width: "90%", margin: "1rem 0rem" }}
                >
                  <thead>
                    <tr style={{ paddingBottom: "1rem" }}>
                      <th>Id</th>
                      <th>Product Title</th>
                      <th>Slug</th>
                      <th>Label</th>
                      <th>HSN</th>
                      <th>Description</th>
                    </tr>
                  </thead>

                  <tbody data-aos="zoom-in">
                    {productTypeData.map((x) => (
                      <tr key={x.id}>
                        <td>{x.id}</td>
                        <td>{x.productTitle}</td>
                        <td>{x.slug}</td>
                        <td>{x.label}</td>
                        <td>{x.hsnCode}</td>
                        <td>{x.description}</td>
                        <td>
                          <AiOutlineEdit
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setPopup(true);
                              setProductInUpdate(x);
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </form>
              <div
                style={{
                  height: "auto",
                }}
                className={
                  popUp == true
                    ? "updateAccountDetailsPopupMainBox editCategoryPopBox"
                    : "none"
                }
              >
                <div
                  className="updateAccountDetailsPopupCloseBtn"
                  style={{ margin: "0.5rem" }}
                >
                  <AiOutlineClose
                    size={"3rem"}
                    onClick={() => {
                      setPopup(false);
                      // setShowEdit(!showEdit);
                    }}
                  />
                </div>
                <div
                  style={{ height: "100px", marginBottom: "1rem" }}
                  className={loading == true ? "loading" : "none"}
                >
                  <InfinitySpin
                    className={loading == true ? "loading" : "none"}
                    width="150"
                    color="#4fa94d"
                  />
                </div>
                <div
                  className="editCategoryFormBox"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <form
                    style={{ marginTop: "0", paddingTop: 0 }}
                    onSubmit={handleEdit}
                  >
                    <label htmlFor="category">Category:</label>
                    <select
                      id="category_id"
                      onChange={(e) => handleInputChange(e, "category_id")}
                      placeholder={productInUpdate.category_id}
                    >
                      <option value="">Select an option</option>
                      {categories.map((x) => {
                        return <option value={parseInt(x.id)}>{x.name}</option>;
                      })}
                    </select>
                    <label htmlFor="productTitle">Product Title</label>
                    <input
                      type="text"
                      id="productTitle"
                      onChange={(e) => handleInputChange(e, "productTitle")}
                      placeholder={productInUpdate.productTitle}
                    />
                    <label htmlFor="slug">Slug</label>
                    <input
                      type="text"
                      id="slug"
                      placeholder={productInUpdate.slug}
                      onChange={(e) => handleInputChange(e, "slug")}
                    />
                    <label htmlFor="label">Label</label>
                    <input
                      type="text"
                      id="label"
                      placeholder={productInUpdate.label}
                      onChange={(e) => handleInputChange(e, "label")}
                    />
                    <label htmlFor="hsnCode">HSN</label>
                    <input
                      type="text"
                      id="hsnCode"
                      placeholder={productInUpdate.hsnCode}
                      onChange={(e) => handleInputChange(e, "hsnCode")}
                    />

                    <label htmlFor="description">Description</label>
                    <input
                      type="text"
                      id="description"
                      onChange={(e) => handleInputChange(e, "description")}
                      placeholder={productInUpdate.description}
                    />

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "2fr",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button type="submit" style={{ width: "100%" }}>
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              onClick={() => setPopup(false)}
              className={popUp === true ? "new" : "new2"}
            ></div>
          </div>
        )}
      </div>
    </div>
  );
}
